import { useState } from 'react';

export const useCargarServicio = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  const cargar = async (servicio, params) => {
    setIsLoading(true);

    try {
      const response = await servicio(params);
      if (response.data.error) {
        throw new Error('ERROR_AL_CARGAR_GRUPOS');
      }

      if (Array.isArray(response.data)) {
        setData(response.data);
        return;
      }

      if (Array.isArray(response.data.content)) {
        console.log('SETING_DATA', response.data.content);
        setData(response.data.content);
        return;
      }
    } catch (error) {
      console.error('Error al cargar los grupos:', error);
      setData([]);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    data,
    setData,
    cargar
  };
};
